import React from "react";
import { Box, Checkbox, FormControlLabel, Typography } from "@mui/material";

const ConsentSection = ({ formData, handleChange }) => {
    return (
        <Box>
            <Typography variant="h6" className="mb-3">Consent & Declaration</Typography>

            <Typography variant="body2" sx={{ mt: 1 }}>
                I hereby declare that the information provided is true and correct to the best of my knowledge.
                I authorize the verification of the provided documents and agree to comply with all legal and regulatory requirements.
            </Typography>

            <FormControlLabel
                control={
                    <Checkbox
                        checked={formData.consent}
                        onChange={handleChange}
                        name="consent"
                    />
                }
                label={<> I agree to the above declaration. <span style={{ color: "red" }}>*</span> </>}
                sx={{ mt: 2 }}
            />
        </Box>
    );
};

export default ConsentSection;
